module.exports = __webpack_public_path__ + "static/media/oiliness.0f6ec7b4.svg";